export interface ReportActionCapabilities {
  canSave: boolean;
  canSubmit: boolean;
  canReview: boolean;
  canApprove: boolean;
  canApproveOwn: boolean;
  canValidate: boolean;
  canUploadMedia: boolean;
  canRemoveMedia: boolean;
}

export interface ReportPermissionFlags extends ReportActionCapabilities {
  fieldsEditable: boolean;
  showSave: boolean;
  showSubmit: boolean;
  showReview: boolean;
  showApprove: boolean;
  showValidate: boolean;
  showManualValidate: boolean;
  showUploadMedia: boolean;
}

export function buildReportPermissionFlags(
  workflowEditable: boolean,
  capabilities: ReportActionCapabilities,
  options?: {
    canValidateByWorkflow?: boolean;
    canApproveByWorkflow?: boolean;
    canManualValidateByWorkflow?: boolean;
    isOwnReport?: boolean;
    actionsLocked?: boolean;
  }
): ReportPermissionFlags {
  const canValidateByWorkflow = options?.canValidateByWorkflow ?? false;
  const canApproveByWorkflow = options?.canApproveByWorkflow ?? false;
  const canManualValidateByWorkflow = options?.canManualValidateByWorkflow ?? false;
  const isOwnReport = options?.isOwnReport ?? false;
  const actionsLocked = options?.actionsLocked === true;

  const fieldsEditable =
    !actionsLocked &&
    workflowEditable &&
    (capabilities.canSave || capabilities.canSubmit);

  return {
    ...capabilities,
    fieldsEditable,
    showSave: !actionsLocked && workflowEditable && capabilities.canSave,
    showSubmit: !actionsLocked && workflowEditable && capabilities.canSubmit,
    showReview: !actionsLocked && capabilities.canReview,
    showApprove:
      !actionsLocked &&
      canApproveByWorkflow &&
      capabilities.canApprove &&
      (!isOwnReport || capabilities.canApproveOwn),
    showValidate: !actionsLocked && canValidateByWorkflow && capabilities.canValidate,
    showManualValidate:
      !actionsLocked && canManualValidateByWorkflow && capabilities.canValidate,
    showUploadMedia: fieldsEditable && capabilities.canUploadMedia,
  };
}
